module.exports = __webpack_public_path__ + "media/images/beauty/main_image2@2x-619bd6cfb8b7024cd10a302ff872d36c.jpg";